import { render, staticRenderFns } from "./ConfigureSettings.vue?vue&type=template&id=90524f60&scoped=true"
import script from "./ConfigureSettings.vue?vue&type=script&lang=js"
export * from "./ConfigureSettings.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSettings.vue?vue&type=style&index=0&id=90524f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90524f60",
  null
  
)

export default component.exports